import { Copy, Flex, Stack, SvgCircleX } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface IChildAccountTableErrors {
  children?: string;
}

export const parentLevelErrorsMapping = {
  'more-than-max-allowed-children': 'Max child accounts exceeded',
};

export function ChildAccountTableErrors({
  children,
}: IChildAccountTableErrors): JSX.Element {
  if (!children) {
    return null;
  }

  return (
    <Flex justifyContent="flex-end" role="status">
      <Flex aria-label="Error" color="danger" alignItems="center">
        <Copy variant="body" color="danger">
          <Stack x="sm" height="100%">
            <SvgCircleX
              size="20px"
              color="secondaryText"
              aria-label="Error icon"
            />
          </Stack>
        </Copy>
        {children}
      </Flex>
    </Flex>
  );
}
